import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/root/recordList/resourceTimeOverview/styles.scss';export default {
  "resourceTimeOverview": "_resourceTimeOverview_d3lv8_1",
  "cell": "_cell_d3lv8_8",
  "text": "_text_d3lv8_21",
  "resource": "_resource_d3lv8_1",
  "list": "_list_d3lv8_30",
  "task": "_task_d3lv8_42",
  "numberInput": "_numberInput_d3lv8_46",
  "percentSign": "_percentSign_d3lv8_55",
  "progression": "_progression_d3lv8_59"
};